// extracted by mini-css-extract-plugin
module.exports = {"container":"TournamentsNav_container__3R2gk","active":"TournamentsNav_active__3SQSu","blue":"TournamentsNav_blue__1Iq0Q"};